import { yupResolver } from "@hookform/resolvers/yup/dist/yup";
import { useForm } from "react-hook-form";
import StateForm from "./StateForm";
import { stateValidationForm } from "../../utils/validationSchemas";
//@ts-ignore
import { FormLayout } from "@careinfo/layout";

const CreateState = (props: any) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    setError,
    getValues,
    clearErrors,
  } = useForm<any>({
    resolver: yupResolver(stateValidationForm),
  });

  const { handleCreate, isLoading } = props;
  return (
    <FormLayout
      handleSubmit={handleSubmit}
      handleFormSubmit={handleCreate}
      setError={setError}
      buttonLabel={"Create"}
      isLoading={isLoading}
    >
      <StateForm
        clearErrors={clearErrors}
        errors={errors}
        register={register}
        setValue={setValue}
        getValues={getValues}
      />
    </FormLayout>
  );
};

export default CreateState;
